import React from 'react'
import { useField } from 'formik'

import { CheckboxProps, WithCheckboxProps } from './interface'

const withCheckbox = (Component: React.FC<CheckboxProps>) => {
  function Hoc({ onChange, name, ...props }: WithCheckboxProps) {
    const [{ value, ...field }] = useField(name)

    function handleChange(e: React.ChangeEvent<HTMLInputElement>) {
      field.onChange(e)

      if (onChange) {
        onChange(e)
      }
    }

    const newProps = {
      ...props,
      ...field,
      checked: value,
      onChange: handleChange,
    }

    return <Component {...newProps} />
  }

  return Hoc
}

export { withCheckbox }
